import { defineEffect } from '../../../core/effect';
import { chainSolvingSpec } from '../fx/chainSolving';

/** 無効にされたリンクの処理（灰色で沈む。対象の照準を消す）（Issue #589。状況は共通側の `editorPorts/duelSituations/chain_solving.js` が決め、絵の組み立ては `../fx/chainSolving.js`） */
export default defineEffect({ situation: 'chain_solving_sink', role: 'effect', ...chainSolvingSpec('sink') }, 'chain_solving_sink_effect.js');
